import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const ProductStockStatusContainer = ({ params, isPlainText = false }) => {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (params) {
      setStatus(params);
      console.log("params:", params);
    }
  }, [params]);
  return (
    <Fragment>
      {status && (
        <Fragment>
          {status.isSubstitute == true ? (
            <Fragment>
              {isPlainText ? (
                <div className="product-instock">
                  <p style={{ color: "rgb(33, 109, 227)" }}>
                    Product is unavailable and replace with code:{" "}
                    <Link
                      style={{ color: "rgb(51, 153, 51)", fontWeight: "bold" }}
                      to={status.replaceUrl ?? status.redirectUrl}
                    >
                      {status.substituteCode}
                    </Link>
                  </p>
                </div>
              ) : (
                <div className="spl-badge ship-info">
                  <div className="d-block">
                    <span className="text-black small">
                      <b>Substituted </b>
                      <br />
                      Replacement Item:
                    </span>
                    <span className="product-instock fs-13 pl-2">
                      <Link className="spl-badge" to={status.replaceUrl ?? status.redirectUrl}>
                        {status.substituteCode}
                      </Link>
                    </span>
                  </div>
                </div>
              )}
            </Fragment>
          ) : status.isDiscontinued == false && status.isUnavailable == false ? (
            <span className="product-instock" style={{ color: "#339933", fontWeight: "bold" }}>
              {status.stockStatus}
            </span>
          ) : (
            <span
              className="product-instock m-0 fs-13 fw-semibold"
              dangerouslySetInnerHTML={{ __html: status.stockStatus }}
            ></span>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};
